import { Box, Theme, Typography, useMediaQuery } from "@mui/material";
import {
    List,
    SearchInput,
    useListContext,
    TopToolbar,
    FilterButton,
    SortButton,
    useGetResourceLabel,
    TextInput,
    useTranslate,
    BooleanInput,
} from "react-admin";
import MobileGrid from "./MobileGrid";
import CoreCreateButton from "../../../../shared/components/core/CoreCreateButton";
import { customsHouseExporter } from "../../../../shared/utilities/adminExporter";
import SacopExportButton from "../../../../shared/components/core/SacopExportButton";

const ListActions = () => (
    <TopToolbar>
        <CoreCreateButton permission="BACKOFFICE_CUSTOMS_C" />
        <SortButton fields={["name"]} />
        <FilterButton />
        <SacopExportButton exporter={customsHouseExporter} />
    </TopToolbar>
);

const templateFilters = [
    <SearchInput source="q" alwaysOn />,
    <TextInput source="name" />,
    <BooleanInput source="active" />
];

const TabbedDatagrid = () => {
    const listContext = useListContext();
    const isXSmall = useMediaQuery<Theme>((theme) =>
        theme.breakpoints.down("sm")
    );
    return <MobileGrid {...listContext} />;
};

const CustomsHouseList = () => {
    const getResourceLabel = useGetResourceLabel();
    return (
        <List
            filterDefaultValues={ { active: true }}
            sort={{ field: "name", order: "DESC" }}
            perPage={25}
            filters={templateFilters}
            actions={<ListActions />}
            exporter={customsHouseExporter}
            title="Lista de Aduanas"
        >
            <TabbedDatagrid />
        </List>
    );
};

export default CustomsHouseList;
